'use client';

import { useState } from 'react';
import { useLanguageStore, type Language } from '../stores/languageStore';

interface LanguageHydratorProps {
  /** Locale resolved server-side from the `shot_lang` cookie or the
   * Accept-Language header. Same value the root layout uses for
   * `<html lang>` — both sides MUST agree to avoid translation
   * flicker on hydration. */
  initial: Language;
}

/**
 * Seeds the Zustand language store with the server-resolved locale
 * before any other component reads it. Runs synchronously inside
 * `useState`'s initializer (NOT a useEffect) so the very first
 * client render uses the same language the server rendered with —
 * no "Войти" → "Login" translation flash on EN/UZ visitors.
 *
 * Returns null; it only exists for the side effect on the
 * module-scoped Zustand store.
 */
export function LanguageHydrator({ initial }: LanguageHydratorProps): null {
  useState(() => {
    const current = useLanguageStore.getState().language;
    if (current !== initial) {
      useLanguageStore.setState({ language: initial });
    }
    return true;
  });
  return null;
}
